export default function setupTrustPilot() {
  if (typeof window !== 'undefined' && !window.Trustpilot) {
    ((doc, scr) => {
      const elem = doc.createElement(scr);
      const elemParent = doc.getElementsByTagName(scr)[0];
      elem.async = true;
      elem.setAttribute('charset', 'utf-8');
      elem.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      elem.type = 'text/javascript';
      elemParent.parentNode.insertBefore(elem, elemParent);
    })(document, 'script');
  }
}



// WEBPACK FOOTER //
// ./spa/vendor/trustpilot.jsx